export function validateForNonAscii (email) {
  const containsPunycode = email?.includes('xn--')
  if (containsPunycode) {
    return `Die von Ihnen eingegebene Domain enthält ungewöhnliche Sonderzeichen und wird als Sonderzeichen-Domain verarbeitet: ${email}. Bitte überprüfen Sie die eingegebene E-Mail Adresse, ob dies beabsichtigt ist.`
  }
  return null
}

export default {
  validateForNonAscii
}
